export default {
      id: "ic_double_arrow-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_double_arrow-usage",
      toString: function () {
        return this.url;
      }
    }